import type { MenuItem } from '../schemas/menuItemSchema';

const UPGRADE_TO_CONSULTANT_KEY = 'become-consultant';
const UPGRADE_TO_BRAND_PARTNER_KEY = 'upgrade-to-brand-partner';

const filterMenuItems = (items: MenuItem[], isDesktop: boolean): MenuItem[] =>
  isDesktop
    ? items
    : items.filter(
        (x) => !x.url?.includes(UPGRADE_TO_CONSULTANT_KEY) && !x.url?.includes(UPGRADE_TO_BRAND_PARTNER_KEY),
      );

const findUrl = (menuItems: MenuItem[], key: string): string => menuItems.find((x) => x.url?.includes(key))?.url ?? '';

export const useMenuItemsFilter = (
  items: MenuItem[],
  isDesktop: boolean,
): {
  filteredItems: MenuItem[];
  upgradeToConsultantUrl: string;
  upgradeToBrandPartnerUrl: string;
} => ({
  filteredItems: filterMenuItems(items, isDesktop),
  upgradeToConsultantUrl: findUrl(items, UPGRADE_TO_CONSULTANT_KEY),
  upgradeToBrandPartnerUrl: findUrl(items, UPGRADE_TO_BRAND_PARTNER_KEY),
});
